import React, { useContext } from "react"
import PropTypes from "prop-types"
import { mediaQuery } from "@zendeskgarden/react-theming"
import styled from "styled-components"
import { searchResult } from "../../lib/prop-types"
import SearchModalContext from "./searchModalContext"
import SearchResult from "./searchResult"

const Heading = styled.h6`
  margin: ${props => `0 -${props.theme.space.lg} ${props.theme.space.sm}`};
  padding: ${props => `${props.theme.space.lg} ${props.theme.space.lg} 0`};
  color: ${props => props.theme.colors.search.searchHeader};
  font-weight: ${props => props.theme.fontWeights.semibold};
  text-transform: uppercase;
  border-top: ${props =>
    `${props.theme.borders.sm} ${props.theme.colors.document.horizontalRule}`};

  ${props => mediaQuery("down", "sm", props.theme)} {
    margin-right: ${props => `-${props.theme.space.horz.md}`};
    margin-left: ${props => `-${props.theme.space.horz.md}`};
    padding-right: ${props => props.theme.space.horz.md};
    padding-left: ${props => props.theme.space.horz.md};
  }
`

const SearchResultList = styled.ul`
  margin: ${props => `0 -${props.theme.space.lg}`};

  ${props => mediaQuery("down", "sm", props.theme)} {
    margin: ${props =>
      `0 -${props.theme.space.horz.md} ${props.theme.space.sm}`};
  }
`

const RecentlyViewed = ({ results }) => {
  const { resultsListRef } = useContext(SearchModalContext)
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {results.length !== 0 && (
        <>
          <Heading id="search-history-heading">Recently Viewed</Heading>
          <SearchResultList
            ref={resultsListRef}
            aria-labelledby="search-history-heading"
          >
            {results.map(result => (
              <li key={result.slug}>
                <SearchResult
                  title={result.title}
                  slug={result.slug}
                  breadcrumbs={result.breadcrumbs}
                />
              </li>
            ))}
          </SearchResultList>
        </>
      )}
    </>
  )
}

RecentlyViewed.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape(searchResult)).isRequired
}

export default RecentlyViewed
